import { SelectOpt } from '../../common/CommonTypes';
import SelectInput from '../selectInput/SelectInput';
import { useTranslation } from 'react-i18next';

export const Countries: SelectOpt[] = [
    {
        id: 'United States',
        text: 'United States',
        value: 'United States',
        disabled: false
    },
    {
        id: 'Canada',
        text: 'Canada',
        value: 'Canada',
        disabled: false
    },
    {
        id: 'Other',
        text: 'Other',
        value: 'Other',
        disabled: false
    }
];
export type LocationCountryProps = {
    locationCountry: string;
    onChangeLocationCountry: (selectedValue: string) => void;
};
const LocationCountry = ({
    locationCountry,
    onChangeLocationCountry
}: LocationCountryProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <SelectInput
            className='country-location-select-padding '
            name='location-country'
            loadingText={t('loading')}
            label={t('select_country')}
            value={locationCountry}
            options={Countries}
            onChange={onChangeLocationCountry}
            forceDefault
            defaultIfOneOption
            addDefaultOption
            defaultText={t('select_default')}
        />
    );
};

export default LocationCountry;
